import { useMemo } from 'react'
import { graphql, useStaticQuery } from 'gatsby'

export const query = graphql`
  query {
    allNodeSlide(
      limit: 3,
      filter: {status: {eq: true}},
      sort: {fields: changed, order: DESC}
    ) {
      edges {
        node {
          title
          body {
            processed
          }
          field_link {
            uri
            title
          }
          relationships {
            field_mc_image {
              gatsbyImage(fit: COVER, formats: AUTO, quality: 100, width: 500)
            }
          }
        }
      }
    }
  }
`

const formatSlides = ({ edges }) => {
  return edges.map(({ node }) => {
    let image = false
    if (node.relationships.field_mc_image) {
      image = node.relationships.field_mc_image.gatsbyImage
    }

    const result = {
      title: node.title,
      content: node.body ? node.body.processed : '',
      path: node.field_link,
      image: image
    }

    if (node.field_link && node.field_link.uri) {
      result.link = {
        title: node.field_link.title,
        href: node.field_link.uri
      }
    }
    else {
      result.link = false
    }

    return result
  })
}

export const useSlides = () => {
  const { allNodeSlide } = useStaticQuery(query)
  return useMemo(() => formatSlides(allNodeSlide), [allNodeSlide])
}
